import { Dispatch, SetStateAction, createContext, useContext } from 'react'

export type GuidelineDrawerMode = 'create' | 'edit'

export interface GuidelineDrawerState {
  open: boolean
  mode: GuidelineDrawerMode
  guidelineId?: number
}

export type GuidelineDrawerActions = {
  openCreate: () => void
  openEdit: (guidelineId: number) => void
}

export type GuidelineDrawerContext = GuidelineDrawerActions & {
  drawer: GuidelineDrawerState
  setDrawer: Dispatch<SetStateAction<GuidelineDrawerState>>
  close: () => void
}

export const guidelineDrawerContext = createContext<GuidelineDrawerContext | null>(null)

export const useGuidelineDrawer = () => {
  const context = useContext(guidelineDrawerContext)

  if (!context) {
    throw new Error('useGuidelineDrawer must be used inside GuidelineDrawerProvider')
  }

  return context
}
